import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Grid } from "@material-ui/core";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),
      display: "flex",
    },
  },
  gridRoot: {
    flexGrow: 1,
    marginBottom: "20px",
  },
  helperText: {
    color: "red",
  },
}));

export const PhoneInputComp = (props: any) => {
  const classes = useStyles();

  const { label, helpertext, index, value, grid, handleChange, disabled } =
    props.componentObject;

  return (
    <PhoneInput
      country={"gb"}
      value={value}
      onChange={(val) => handleChange(val, index)}
      disabled={disabled}
    />
  );
};

export default function PhoneComponent(props: any) {
  const classes = useStyles();
  const { label, helpertext, errorMsg, grid } = props.componentObject;
  return (
    // <form style={{ display: "flex", marginBottom: '20px' }} noValidate autoComplete="off">
    <Grid container className={classes.gridRoot}>
      {/* <div style={{ width: "25%" }}>{label}</div> */}
      {(label || grid === "yes") && (
        <Grid item xs={12} md={4}>
          {label}
        </Grid>
      )}
      {/* <div style={{ width: "70%" }}> */}
      <Grid
        item
        xs={12}
        md={label || grid === "yes" ? 7 : 12}
        style={{ width: "100%" }}
      >
        <PhoneInputComp
          style={{ width: "100%", borderColor: "red" }}
          componentObject={props.componentObject}
        />
        {errorMsg !== undefined ? (
          <span
            style={{
              color: "#f44336",
              fontSize: "0.75rem",
              marginRight: "14px",
            }}
          >
            {errorMsg}
          </span>
        ) : (
          ""
        )}
      </Grid>
    </Grid>
    // </form>
  );
}
